// extracted by mini-css-extract-plugin
export default {"feedback-popover":"FeedbackPopover_feedback-popover__Ia2ya","feedback-popover-list":"FeedbackPopover_feedback-popover-list__z776i"};